// src/context/filecontext.js
import React, { createContext, useContext, useRef, useState } from 'react';

const FileContext = createContext();
export const reactStates = {};
export const FileProvider = ({ children }) => {
  // Initialize metadataUrl from localStorage
  const loaderRef = useRef(null);
  const loaderText = useRef(null);
  const [designLGlbUrl, setDesignLGlbUrl] = useState('');

  const actualGlbUrl = ""
  
  function sleep(inMs) {
    return new Promise((resolve) => setTimeout(resolve, inMs));
}
  const showLoader = async (text, inMs = 0)=>{
    if (!loaderRef.current) return;
    loaderRef.current.classList.remove("displayNone")
    loaderText.current.innerHTML = text;
    await sleep(inMs);
  }

  const removeLoader = ()=>{
    if (!loaderRef.current) return;
    loaderRef.current.classList.add("displayNone")
  }

  const [metadataUrl, setMetadataUrl] = useState(() => {
    try {
      const savedUrl = localStorage.getItem('metadataUrl');
      return savedUrl || null;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  });
    const [currentMeasurements, setCurrentMeasurements] = useState({
      volume: { totalVolume: 0, surfaceArea: 0 },
      overbreak: { volume: 0, percentage: 0, maxLength: 0 },
      underbreak: { volume: 0, percentage: 0, maxLength: 0 },
      density: { pointDensity: 0, coverage: 0 },
      plannedDesignVolume : {
        volume : 0,
      },
      oreDillution : 0,
    });
  const [designLasUrl, setDesignLasUrl] = useState(() => {
    try {
      const savedUrl = localStorage.getItem('designLasUrl');
      return savedUrl || null;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  });

  // Initialize uploadResponseData from localStorage
  const [uploadResponseData, setUploadResponseData] = useState(() => {
    try {
      const savedData = localStorage.getItem('uploadResponseData');
      return savedData ? JSON.parse(savedData) : null;
    } catch (error) {
      console.error('Error reading upload data from localStorage:', error);
      return null;
    }
  });

  // Notification state
  const [showNotification, setShowNotification] = useState(false);
  const [notificationConfig, setNotificationConfig] = useState(null);

  // Function to clear all stored data
  const clearMetadataUrl = () => {
    try {
      localStorage.removeItem('metadataUrl');
      localStorage.removeItem('uploadResponseData');
      setMetadataUrl(null);
      setUploadResponseData(null);
    } catch (error) {
      console.error('Error clearing data:', error);
    }
  };

  // Helper function to show notifications
  const showNotificationWithConfig = ({ type, message, duration }) => {
    setNotificationConfig({
      type: type || 'info',
      message: message,
      duration: duration || 5000
    });
    setShowNotification(true);
  };

  // Save metadataUrl to localStorage whenever it changes
  React.useEffect(() => {
    try {
      if (metadataUrl) {
        localStorage.setItem('metadataUrl', metadataUrl);
      }
      if (uploadResponseData) {
        localStorage.setItem('uploadResponseData', JSON.stringify(uploadResponseData));
      }
      if (designLasUrl) {
        localStorage.setItem('designLasUrl', designLasUrl);
      }
    } catch (error) {
      console.error('Error saving metadataUrl to localStorage:', error);
    }
  }, [metadataUrl,uploadResponseData,designLasUrl]);


  // Auto-hide notification after duration
  React.useEffect(() => {
    if (showNotification && notificationConfig) {
      if (notificationConfig.duration < 0) return;
      const timer = setTimeout(() => {
        setShowNotification(false);
        setNotificationConfig(null);
      }, notificationConfig.duration);

      return () => clearTimeout(timer);
    }
  }, [showNotification, notificationConfig]);

  // Create a function to update upload response data
  const updateUploadResponseData = (newData) => {
    try {
      setUploadResponseData(prevData => ({
        ...prevData,
        ...newData
      }));
    } catch (error) {
      console.error('Error updating upload response data:', error);
      showNotificationWithConfig({
        type: 'error',
        message: 'Failed to update upload data'
      });
    }
  };

  let states = {
    metadataUrl,
    setMetadataUrl,
    clearMetadataUrl,
    showNotification,
    setShowNotification,
    notificationConfig,
    showNotificationWithConfig,
    uploadResponseData,
    setUploadResponseData,
    updateUploadResponseData,
    designLasUrl,
    setDesignLasUrl,
    currentMeasurements,
    setCurrentMeasurements,
    loaderRef,
    loaderText,
    showLoader,
    removeLoader,
    designLGlbUrl,
    actualGlbUrl,
    setDesignLGlbUrl,
  }
  reactStates.current = states;

  return (
    <FileContext.Provider value={states}>
      {children}
    </FileContext.Provider>
  );
};

export const useFile = () => {
  const context = useContext(FileContext);
  if (!context) {
    throw new Error('useFile must be used within a FileProvider');
  }
  return context;
};

export default FileContext;